// @flow
import React from 'react';
import { makeStyles } from '@material-ui/styles';

import CheckmarkIcon from './Icons/Checkmark';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  text: {
    marginRight: 12,
    color: theme.palette.ava.states.online,
    fontSize: 18,
    lineHeight: '23px',
  },
  icon: {
    marginTop: 4,
  },
}));

interface Props {
  message: string;
}

const ValidatedMessage = ({ message }: Props) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.text}>{message}</div>
      <div className={classes.icon}>
        <CheckmarkIcon width={20} height={20} />
      </div>
    </div>
  );
};

export default ValidatedMessage;
